import { Pause } from '../pause';

export class ModelCurrentTaskProgram {
  public open = false;

  constructor(
    public hash: string,
    public time: number,
    public programIndex: number,
    public current: boolean,
    public subactivityHash?: string,
    public subactivityName?: string,
    public startTime?: number,
    public endTime?: number,
    public disabled?: boolean,
    public pauses?: Pause[]
  ) { }

  toggleOpen() {
    this.open = !this.open;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-current-task-program.ts